import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import { connect } from 'react-redux';

const DashboardHeader = () => {
  useEffect(() => {}, []);

  return (
    <Grid container className='page-header'>
      <Grid item size={{ xs: 12 }}>
        <Grid container direction={'row'}>
          <Grid item size={{ xs: 6 }} textAlign={'start'}>
            <h3>Mis Ventas</h3>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

// export default Modal;
const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardHeader);
